/**
 * @generated SignedSource<<f2a657068937c6aa6a81c11e73598f6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type recoilGetPropertiesInSubmissionQuery$variables = {
  submissionId: number;
};
export type recoilGetPropertiesInSubmissionQuery$data = {
  readonly sys_property_batches: ReadonlyArray<{
    readonly properties_flattened_union: {
      readonly parent_property_id: number | null;
      readonly property_id: number;
    } | null;
  }>;
};
export type recoilGetPropertiesInSubmissionQuery = {
  response: recoilGetPropertiesInSubmissionQuery$data;
  variables: recoilGetPropertiesInSubmissionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "submissionId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "submissionId"
              }
            ],
            "kind": "ObjectValue",
            "name": "submission_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_property_batches",
    "kind": "LinkedField",
    "name": "sys_property_batches",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_properties_flattened_union",
        "kind": "LinkedField",
        "name": "properties_flattened_union",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "property_id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parent_property_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recoilGetPropertiesInSubmissionQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recoilGetPropertiesInSubmissionQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "facf803dbe33a404a2e7eae49d452f68",
    "id": null,
    "metadata": {},
    "name": "recoilGetPropertiesInSubmissionQuery",
    "operationKind": "query",
    "text": "query recoilGetPropertiesInSubmissionQuery(\n  $submissionId: Int!\n) {\n  sys_property_batches(where: {submission_id: {_eq: $submissionId}}) {\n    properties_flattened_union {\n      property_id\n      parent_property_id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a460dd634c526b8b94f60f6cf9601bcf";

export default node;
